import { render, staticRenderFns } from "./UnionActivity.vue?vue&type=template&id=5a0a9da4&scoped=true&"
import script from "./UnionActivity.vue?vue&type=script&lang=js&"
export * from "./UnionActivity.vue?vue&type=script&lang=js&"
import style0 from "./UnionActivity.vue?vue&type=style&index=0&id=5a0a9da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a9da4",
  null
  
)

export default component.exports